export default "__VITE_ASSET__DO1Nt2ol__"